import { gql } from "@apollo/client";

/* AVA ID */

export const SubmitPartialLead = gql`
    mutation submitPartialLead(
        $widgetId: String!,
        $input: LeadInput!,
        $product: ProductType!
    ) {
        submitLead(
            widgetId: $widgetId,
            input: $input,
            productType: $product
        ) {
            leadId
            success
        }
    }
`;

export const RetrieveTemplate = gql`
    query RetrieveTemplate($leadId: UUID!) {
      idVerificationTemplate(leadId: $leadId) {
        alreadyVerified
        isIdEnabled
        templateType
        nextStep
        success
        provider
        redirectUrl
      }
    }
`;

export const UploadIdVerificationImage = gql`
  mutation UploadIdVerificationImage($input: UploadAutocorpIdImageInput!) {
    uploadIdVerificationImage(input: $input) {
      success
      nextStep
      issues
      issueDetails
    }
  }
`;

export const RetrieveIdVerification = gql`
    mutation RetrieveIdVerification($leadId: UUID!) {
      retrieveIdVerification(leadId: $leadId) {
        data {
          action
          createdAt
          customerUid
          dashboardUrl
          entity
          firstStep
          nextStep
          flags
          id
          images {
            liveness
            front {
              croppedImage
              faceImage
              fullImage
            }
          }
          verificationUrl
          fields {
            idType {
              value
            }
            addressCountry {
              value
            }
          }
        }
        success
      }
    }
`;

/* AVA INCOME */
export const RetrieveIncomeVerification = gql`
    query RetrieveIncomeVerification($leadId: UUID!) {
      retrieveIncomeVerification(leadId: $leadId) {
        incomeVerifiedAt
        success
      }
    }
`;

export const SetIncomeLogin = gql`
    mutation SetIncomeLogin($leadId: UUID!, $loginId: String!, $accountId: String!) {
      setIncomeLogin(leadId: $leadId, loginId: $loginId, directDepositAccountId: $accountId) {
        loginId
        success
      }
    }
`;

/** @deprecated */
export const SetDirectDepositAccount = gql`
    mutation SetDirectDepositAccount($leadId: UUID!, $accountId: String!) {
      setDirectDepositAccount(leadId: $leadId, accountId: $accountId) {
        directDepositAccountId
        success
      }
    }
`;

/* CREDIT */
export const GetCreditConsentStatus = gql`
	query GetCreditConsentStatus($accessToken: String!) {
    creditConsentStatus(accessToken: $accessToken) {
      companyDetails {
        groupId
        id
        name
        widgetId
      }
      consentAlreadyGiven
      firstName
      lastName
      leadId
    }
	}
`;

export const CreditConsent = gql`
  mutation CreditConsent($dealerCreditConsent: Boolean!, $accessToken: String!) {
    creditConsent(dealerCreditConsent: $dealerCreditConsent, accessToken: $accessToken) {
      assessmentComplete {
        passed
        reasons {
          description
          value
        }
      }
      consumer
      equifaxErrorMessages
      equifaxServerError
      fieldErrors
      fraudCheckFailed
      interactiveQuery {
        queryId
        questions {
          answers {
            answerId
            value
          }
          questionId
          questionText
        }
      }
      report {
        expired
        inquiries {
          date
          fields
          inquirer {
            id
            name
            phone
          }
        }
        score {
          reasons
          value
        }
        trades {
          accountNumber
          association
          balanceAmount
          creditor {
            id
            name
            phone
          }
          date
          dateLastActivityOrPayment
          dateOpened
          derogatoryCounters {
            past30
            past60
            past90
          }
          fields
          highCreditAmount
          lastSlowPayment
          monthsReviewed
          narratives
          pastDueAmount
          paymentRate {
            code
            description
          }
          paymentTerm
          paymentTermAmount
          portfolioType {
            code
            description
          }
          updateSource
        }
      }
      transactionKey
    }
}`;


